import pageTransition from "@/lib/page-transition"
import { handleTab } from "@/lib/a11y"
import widthWatch from "@/lib/width-watcher"
import { dialog } from "@/lib/modals.js"
import "@/lib/navigation"

import * as cart from "@/lib/cart.js"
import EVENTS from "@/lib/events.js"
import "./sections/header-group.js"

// Import sections
import "@/sections"

// Page transitions
pageTransition()

// a11y tab handler
handleTab()

// widthWatch breakpoint emmiter
widthWatch()

// Initialize modals
document
  .querySelectorAll("dialog[data-fluco-dialog]")
  .forEach((el) => dialog(el))

// Maintain a local representation of the cart so it's accessible to JS
cart.get().then((cartData) => {
  window.theme.cartData = cartData
})

document.addEventListener(EVENTS.CART_CHANGED, (event) => {
  window.theme.cartData = event.detail.cart
})

document.addEventListener(EVENTS.CART_ITEM_ADDED, () => {
  if (window.flu.cartType === "drawer") {
    window.dispatchEvent(new Event(EVENTS.CART_DRAWER_OPEN))
  } else {
    window.location = window.theme.routes.cart.base
  }
})

// Listen for custom event that apps can use to refresh the cart/cart count
document.addEventListener("apps:product-added-to-cart", () => {
  fetch(`${window.theme.routes.cart.base}.js`)
    .then((res) => res.json())
    .then((cartData) => {
      document.dispatchEvent(
        new CustomEvent(EVENTS.CART_CHANGED, {
          detail: { cartData },
        }),
      )
      if (window.flu.cartType === "drawer") {
        window.dispatchEvent(new Event(EVENTS.CART_DRAWER_OPEN))
      }
    })
})

// Make it easy to see exactly what theme version
// this is by commit SHA
window.SHA = "__gitSHA"

if (
  !sessionStorage.getItem("flu_stat_recorded") &&
  !window.Shopify?.designMode
) {
  // eslint-disable-next-line no-process-env
  fetch(process.env.FLU_STATS_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      ...window.theme.coreData,
      s: window.Shopify?.shop,
      r: window.Shopify?.theme?.role,
    }),
  })

  if (window.sessionStorage) {
    sessionStorage.setItem("flu_stat_recorded", "true")
  }
}
